import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import Utility from "../../utility/Utility";

/*
PROPS
- url
- className
*/

class DirectLinkSection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className={
          "p-xl border-radius-s bg-gray1 column flex-shrink-0 parent-width border-m " +
          this.props.className
        }
      >
        <DKLabel className="fw-b fs-m" text="Direct link" />
        <DKLabel
          className="text-gray mt-xs"
          text="Share this link with your contacts securely to view."
        />
        <div className="row mt-l ">
          <div
            className="cursor-hand"
            onClick={() => {
              window.open(this.props.url, "_blank");
            }}
          >
            <DKLabel
              text={this.props.url}
              className="bg-white border-m border-radius-s p-r border-box text-blue  word-break-all"
            />
          </div>
          <DKButton
            title="Copy link"
            icon={DKIcons.ic_copy}
            onClick={() => {
              Utility.copyToClipBoard(this.props.url);
            }}
            style={{ paddingRight: 0 }}
          />
        </div>
      </div>
    );
  }
}

export default DirectLinkSection;
